/**
 * Koduje URL pod atrybut `srcset` / `srcSet`.
 *
 * W `srcset` spacja rozdziela kandydatów. Niezakodowane spacje / Unicode w nazwie pliku
 * (np. CDN: `Szare ściany – ….webp`) powodują, że przeglądarka odrzuca cały `<source>`
 * i zostaje tylko fallback `<img src>` — często wariant mobile.
 */
const encodeSrcSetUrl = (url: string): string => {
  if (!url || url.startsWith('data:')) return url;
  try {
    return encodeURI(url);
  } catch {
    return url;
  }
};
export default encodeSrcSetUrl;